<template>
  <div class="main-container">
    <div v-if="userIsAParent" class="h-100 bg-plain">
      <parent-main />
    </div>
    <div v-else class="h-100 bg-plain">
      <child-main />
    </div>
  </div>
</template>

<script>
import { useSessionStore } from '@/common'
import { ChildMain, ParentMain } from "@/common/components";

export default {
  data(){
    const sessionStore = useSessionStore() 
    return {
      sessionStore
    }
  },
  components: {
    ChildMain,
    ParentMain
  },
  computed: {
    userIsAParent(){
      return this.sessionStore.userIsAParent
    },
  },
};
</script>

<style lang="scss">
.main-container {
  .mobile {
    @media (max-width: 768px) {
      border-radius: 2rem;
      margin-top: -2rem;
      overflow: hidden;
    }
  }
  .dummy-container {
    @media (min-width: 768px) {
      display: none;
    }
  }
}
</style>
